/**
 * JavaScript for Class Schedule.
 */

(function () {
	'use strict';

	// Get all input fields.
	const allFormInputs = document.querySelectorAll(
		'#additional-search-container input, #additional-search-container select, #additional-search-container option'
	);

	// Get the toggle/switch for showing/hiding Advanced Search.
	const advancedToggle = document.getElementById('additional-search-toggle');

	/**
	 * Disable advanced search input fields if the toggle for advanced search is disabled. This will
	 * prevent an advanced search from being done when values are set but the advanced toggled is
	 * set to NOT do an advanced search.
	 */
	advancedToggle.addEventListener('click', function () {
		if ('false' === advancedToggle.getAttribute('aria-expanded')) {
			allFormInputs.forEach((input) => {
				input.setAttribute('disabled', true);
			});
		} else {
			allFormInputs.forEach((input) => {
				input.removeAttribute('disabled');
			});
		}
	});
})();
